import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentContainer } from '../../components/base/contentContainer/contentContainer';
import { Column, Columns } from '../../components/base/grid';
import { PageContainer } from '../../components/base/pageContainer/pageContainer';
import RichTextTitle from '../../components/base/richTextTitle';
import SVG from '../../components/rawSVG/rawSVG';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { ReactComponent as Njall } from '../../icons/njall-start-icon-normal.svg';
import IAppFrameViewModel from '../../interfaces/umbracoNodes/appFrameViewModel';

const ComponentWrapper = styled.div`
	font-family: ${theme.fonts.Arimo};
	color: ${theme.colorsV2.mainDark};
	letter-spacing: 0;

	${media.desktopSmall`
		margin-top: 150px;
	`};
`;

const ColImage = styled(Column)`
	${media.tablet`
		order: 2;
    `};
`;

const ColText = styled(Column)`
	${media.tablet`
		order: 1;
    `};
`;

const ContentBlock = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

const RichTextTitleStyled = styled(RichTextTitle)`
	${media.mobileAndTabletOnly`
		margin-top: 40px;
	`};
`;

const Description = styled.p`
	margin: 24px 0 48px 0;
	font-size: 20px;
	line-height: 1.5;
`;

const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;

	svg {
		max-width: 500px;
		max-height: 500px;
	}

	${media.desktopSmall`
		justify-content: flex-end;

		svg {
			max-width: 680px;
			max-height: 680px;
		}
	`};
`;

const ServerError: FC = () => {
	const { appFrame }: { appFrame: IAppFrameViewModel } = useSelector(
		(state: { pageReducer: { appFrame: IAppFrameViewModel } }) => state.pageReducer
	);
	return (
		<PageContainer>
			<ContentContainer>
				<ComponentWrapper>
					<Columns>
						<ColImage tablet={5 / 12} desktopSmall={6 / 12} marginBottom={0}>
							<ContentBlock>
								<IconWrapper>
									{appFrame?.Values?.NotFoundImage?.Src ? (
										<SVG
											src={appFrame?.Values?.NotFoundImage?.Src}
											title={appFrame?.Values?.NotFoundImage?.Name}
											width="100%"
											height="100%"
										/>
									) : (
										<Njall />
									)}
								</IconWrapper>
							</ContentBlock>
						</ColImage>
						<ColText tablet={7 / 12} desktopSmall={6 / 12} marginBottom={0}>
							<ContentBlock>
								<RichTextTitleStyled
									content={appFrame?.Values?.ServerErrorTitle || 'Úps! Upp kom villa hjá okkur'}
								/>
								<Description>
									{appFrame?.Values?.ServerErrorDescription || (
										<>
											<p>Þú getur prufað að endurhlaða síðunni.</p>
											<p>Viltu spjalla við Njál? Hann gæti komið þér til bjargar</p>
										</>
									)}
								</Description>
							</ContentBlock>
						</ColText>
					</Columns>
				</ComponentWrapper>
			</ContentContainer>
		</PageContainer>
	);
};

export default ServerError;
